import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

class ExportPdf extends React.Component {
  constructor() {
    super();
  }

  exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // You can also use "A3" for larger pages
    const orientation = "landscape"; // Landscape often provides more width

    const marginLeft = 20; // Reduce margins for more content width
    const marginTop = 20;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = this.props.title;
    let headers = [];
    if (this.props.type === "report") {
      let header = [];
      this.props.labelHeader.forEach((element) => {
        header.push(element.name);
      });
      headers.push(header);
    } else {
      headers = [this.props.labelHeader];
    }

    let data = [];
    if (this.props.type === "report") {
      this.props.exportData.forEach((el) => {
        let dataKey = [];
        this.props.labelHeader.forEach((element) => {
          dataKey.push(el[element.keyName]);
        });
        data.push(dataKey);
      });
    } else {
      data = this.props.exportData.map((elt) => [
        elt.col1,
        elt.col2,
        elt.col3,
        elt.col4,
        elt.col5,
        elt.col6,
        elt.col7,
        elt.col8,
        elt.col9,
        elt.col10,
        elt.col11,
        elt.col12,
        elt.col13,
        elt.col14,
        elt.col15,
        elt.col16,
        elt.col17,
        elt.col18,
        elt.col19,
        elt.col20,
        elt.col21,
        elt.col22,
      ]);
    }

    // Define content and autoTable options
    let content = {
      startY: 40, // Adjust starting position to fit the title
      head: headers,
      body: data,
      styles: { fontSize: 8, cellPadding: 2 }, // Smaller font and padding for more content
      margin: { left: marginLeft, top: marginTop },
      theme: 'striped', // Optional: Use 'striped' for better readability
      columnStyles: { // Optional: Dynamically adjust column widths
        0: { cellWidth: 30 }, // Adjust widths as needed
        1: { cellWidth: 40 },
        // Define widths for other columns as needed
      }
    };

    // Add title
    doc.text(title, marginLeft, 30); // Adjust position if needed

    // Generate table
    doc.autoTable(content);

    // Save the PDF
    doc.save(
      `${this.props.reportName}(${moment(new Date()).format(
        "DD-MM-YYYYThh:mm:ss"
      )}).pdf`
    );
  };

  render() {
    return (
      <div>
        <div id="exportPdfButton" onClick={() => this.exportPDF()}>
          <PictureAsPdfIcon />
        </div>
      </div>
    );
  }
}

export default ExportPdf;
